import { useMemo } from 'react';
import { bindActionCreators } from 'redux';

import { useDispatch, useSelector } from '../context';
import { setSelectedInstance } from '../slices/ops-context-slice';

export const useOpsContext = () => {
  const dispatch = useDispatch();
  const opsContext = useSelector((state) => state.opsContext);
  const actions = useMemo(
    () =>
      bindActionCreators(
        {
          setSelectedInstance,
        },
        dispatch,
      ),
    [dispatch],
  );
  return {
    ...opsContext,
    setSelectedInstance: actions.setSelectedInstance,
  };
};
